export const INITIAL_DATA_LOAD: string = 'campaign:INITIAL_DATA_LOAD';
export const INITIAL_DATA_LOAD_SUCCESS: string =
  'campaign:INITIAL_DATA_LOAD_SUCCESS';

export const loadInitialDatas = () => ({
  type: INITIAL_DATA_LOAD,
});



// WEBPACK FOOTER //
// ./src/modules/campaign/actions/index.js